import { render, staticRenderFns } from "./AtomCollapse.vue?vue&type=template&id=4eded772&scoped=true&"
import script from "./AtomCollapse.vue?vue&type=script&lang=js&"
export * from "./AtomCollapse.vue?vue&type=script&lang=js&"
import style0 from "./AtomCollapse.vue?vue&type=style&index=0&id=4eded772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eded772",
  null
  
)

export default component.exports